
import { createNamespacedHelpers } from 'vuex'
import axios from 'axios'
const { mapGetters: mapGettersPrescription } = createNamespacedHelpers('prescription')
import wcs from '@libs/wcs'

export default {
  name: 'SghRxPrescriptionModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isOrderDetail: {
      type: Boolean,
      default: false,
    },
    prescription: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'manual',
    },
  },

  data() {
    return {
      localVisible: this.visible,
      pdlabel: 'PD',
      pdfBlobUrl: null,
      imageLoaded: false,
    }
  },

  watch: {
    visible(newValue) {
      this.localVisible = newValue
      if(newValue && this.isPdf && this.getFilePath && !this.pdfBlobUrl) this.loadPdf()
      if (newValue) this.imageLoaded = false
    },
  },

  computed: {
    ...mapGettersPrescription(['prescriptionOrderItemData']),
    prescriptionDataFirst() {
      const p = this.prescription || {}
      const showAddColumn = (p?.prescriptionType && p?.prescriptionType !== 'SINGLE_VISION') || p.rightAdd || p.leftAdd

      const headers = ['', 'SPH (Sphere)', 'CYL (Cylinder)', 'Axis']
      if (showAddColumn) headers.push('Add')

      const data = [
        {
          eye: 'OD (Right)',
          sph: p.rightSphere ?? '-',
          cyl: p.rightCyl ?? '-',
          axis: p.rightAxis ?? '-',
          ...(showAddColumn && { add: p.rightAdd ?? '-' }),
        },
        {
          eye: 'OS (Left)',
          sph: p.leftSphere ?? '-',
          cyl: p.leftCyl ?? '-',
          axis: p.leftAxis ?? '-',
          ...(showAddColumn && { add: p.leftAdd ?? '-' }),
        },
      ]

      return [
        {
          title: 'Prescription Data',
          data,
          headers,
        },
      ]
    },

    prescriptionDataSecond() {
      const p = this.prescription || {}
      return [
        {
          title: 'Prismatic Correction',
          data: [
            {
              eye: 'OD (Right)',
              vertical: p.odVPrism ?? '-',
              verticalBase: p.odVPrismBaseDir ?? '-',
              horizontal: p.odHPrism ?? '-',
              horizontalBase: p.odHPrismBaseDir ?? '-',
            },
            {
              eye: 'OS (Left)',
              vertical: p.osVPrism ?? '-',
              verticalBase: p.osVPrismBaseDir ?? '-',
              horizontal: p.osHPrism ?? '-',
              horizontalBase: p.osHPrismBaseDir ?? '-',
            },
          ],
          headers: ['', 'Vertical (Δ)', 'Base Direction', 'Horizontal (Δ)', 'Base Direction'],
        },
      ]
    },

    prescriptionPupillary() {
      const p = this.prescription || {}
      return [
        {
          title: 'Pupillary Distance',
          data: [
            {
              name: 'PD',
              distanceLeft: p.lpDistance ?? '-',
              distanceRight: p.rpDistance ?? '-',
            },
          ],
          headers: ['', 'Left', 'Right'],
        },
      ]
    },

    pdValue() {
      return this.prescription?.pupillaryDistance ?? '-'
    },

    isPdf() {
      return this.prescription?.fileName?.toLowerCase().endsWith('.pdf')
    },
    
    isImage() {
      return /\.(jpg|jpeg|png|gif)$/i.test(this.prescription?.fileName)
    },

    getFilePath() {
      if (this.prescription?.filePath) return this.prescription.filePath
      if (this.prescription?.fileName) {
        const { storeId } = wcs.getStoreConfig()
        const userId = window.constants?.ajaxParams?.userId
        return `${window.location.origin}/wcs/resources/store/${storeId}/prescription/download/${userId}/${this.prescription.fileName}?prescriptionId=${this.prescription.prescriptionId}`
      }

      return null
    },

    isTYP() {
      return wcs.isTYP()
    },
  },

  methods: {
    closePopup() {
      this.$emit('update:visible', false)
    },
    async loadPdf() {
      try {
        const response = await axios.get(this.getFilePath, {
          responseType: 'blob',
        })
        
        const blob = new Blob([response.data], { type: 'application/pdf' })
        this.pdfBlobUrl = URL.createObjectURL(blob)
      } catch (error) {
        console.error('Error on loading PDF:', error)
      }
    },
    redirectToProductPage(prescriptionOrderItemData) {
      const { orderItemUrl } = prescriptionOrderItemData || {}
      window.location.href = `${orderItemUrl}`
    },
  },
}
